import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getDrugClasses } from '@api/lookups';
import { IDrugClass } from '@interfaces/lookups';

export const handleGetDrugClasses = createAsyncThunk<AxiosResponse<IDrugClass[]>, void>(
  'getDrugClasses',
  getDrugClasses,
);
